import React from 'react'
import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, InputAdornment, TextField, Typography } from "@material-ui/core"
import { useDropzone } from 'react-dropzone'
import { cos } from '../../utils/cos'
import { useFeedback } from '../Feedback'
import { useQuery } from 'react-query'
import { ShareAPI } from '../../utils/api'
import { useEffect } from 'react'

type ShareConfigDialogProps = {
  open: boolean,
  type: string,
  typeKey?: number,
  onClose: (save?: boolean)=> void,
}

const ShareConfigDialog = ({ open, type, typeKey,onClose }: ShareConfigDialogProps) => {
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone()
  const [uploadImg, setUploadImg] = React.useState(false)
  const { data } = useQuery(['share/config', type,typeKey], () => ShareAPI.getConfig(type, typeKey), { refetchOnWindowFocus: false })
  const [config, setConfig] = React.useState<Partial<ShareConfig>>()
  const { showToast, showLoading,hideLoading } = useFeedback()
  useEffect(() => {
    if(!data?.type){
      setConfig({type: type,key: typeKey})
    }else{
      setConfig(data)
    }
  }, [data])
  const handleUpload = (files: File[]) => {
    if (!files || files.length < 1) {
      return;
    }
    const file = files[files.length - 1]
    const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))
    setUploadImg(true)
    cos.sliceUploadFile({
      Bucket: 'video-1302643710', /* 必须 */
      Key: 'img/cover/' + filename,              /* 必须 */
      Body: file,
      Region: 'ap-beijing',
      onTaskReady: function (taskId: any) {                   /* 非必须 */
        console.log(taskId);
      },
      onHashProgress: function (progressData: any) {       /* 非必须 */
        console.log(JSON.stringify(progressData));
      },
      onProgress: function (progressData: any) {           /* 非必须 */
        console.log(JSON.stringify(progressData));
      }
    }, (err: any, data: any) => {
      console.log(err || data);
      setUploadImg(false)
      if (!err) {
        setConfig({ ...config, share_image: `https://res.add-coach.com/${data.Key}` })
      } else {
        showToast('封面图上传失败，请重试')
      }
    })
  }

  const handleSaveConfig = () => {
    if(config){
      showLoading('提交中')
      ShareAPI.saveConfig(config).then(res=> {
        hideLoading()
        showToast('保存成功')
        onClose(true)
      }).catch(e=>{
        hideLoading()
        showToast('保存失败')
      })
    }else{
      onClose()
    }
  }

  React.useEffect(() => {
    handleUpload(acceptedFiles)
  }, [acceptedFiles])

  return <Dialog open={open} maxWidth="xs" fullWidth onClose={()=> onClose(false)}>
    <DialogTitle>分享配置</DialogTitle>
    <DialogContent>
      <TextField value={config?.ratio || ''} onChange={e=> setConfig({...config,ratio: e.target.value})} InputProps={{ endAdornment: <InputAdornment position="end">%</InputAdornment> }} label="提成比例" />
      <Box mt={2}>
        <TextField fullWidth label="分享标题" value={config?.share_title || ''} onChange={e=> setConfig({...config,share_title: e.target.value})}/>
      </Box>
      <Box mt={2}>
        <Typography variant="subtitle2">分享图片</Typography>
        <Box width="150px" height="120px" mt={1} position="relative">
          <div {...getRootProps({ className: 'dropzone' })} style={{ minHeight: '120px', border: '1px dashed #e1e1e1', borderRadius: '4px' }}>
            <input {...getInputProps()} />
            <Typography variant="caption" align="center">点击或拖拽封面图至此</Typography>
          </div>
          {config?.share_image && <img src={config.share_image} style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none', cursor: 'pointer', width: '100%', height: '100%' }} />}
          {uploadImg && <Box display="flex" alignItems="center" justifyContent="center" style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
            <CircularProgress size={24} />
          </Box>}
        </Box>
      </Box>
    </DialogContent>
    <DialogActions>
      <Button variant="text" onClick={()=> onClose(false)}>取消</Button>
      <Button onClick={handleSaveConfig}>确定</Button>
    </DialogActions>
  </Dialog>
}

export default ShareConfigDialog